import { useState } from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight'
import { paths } from 'src/router/paths'
import { DateUtils } from 'src/utils/date'
import { COMMUNITY_DEFAULT_IMAGE } from 'src/utils/constants'
import { Icon } from 'src/components'
import NoAccess from 'src/components/Modal/NoAccess'
import { PathParams } from '../../communityHome.types'
import { CommunityCardProps } from './communityCard.types'
import { Image, Wrapper } from './communityCard.styles'

const CommunityCard = ({ community }: CommunityCardProps) => {
  const { lang, membership } = useParams() as PathParams
  const navigate = useNavigate()
  const [openModal, setOpenModal] = useState(false)

  const handleOpenCommunity = () => {
    const { id, isOwnerOrFollower } = community

    if (isOwnerOrFollower) {
      const path = generatePath(paths.COMMUNITY_PATH, {
        lang,
        membership,
        idCommunity: String(id)
      })

      navigate(path)
      return
    }

    setOpenModal(true)
  }

  const closeModal = () => {
    setOpenModal(false)
  }

  return (
    <>
      <Wrapper
        className="_d-flex _justify-content-between _align-items-center _py-4 _px-3 _cursor-pointer"
        data-test="community-card"
        onClick={handleOpenCommunity}
      >
        <div className="_d-flex _align-items-center">
          <Image
            src={community.imageURL || COMMUNITY_DEFAULT_IMAGE}
            alt={community.name}
            className="_rounded-lg"
          />

          <div className="_d-flex _flex-column _pl-4 _pr-3">
            <span className="_font-weight-bold">{community.name}</span>
            <span className="_text-1 _text-gray-600">
              {DateUtils.compareDates(community.lastPostDate, true)}
            </span>
          </div>
        </div>

        <Icon className="_text-5" icon={faArrowRight} />
      </Wrapper>

      <NoAccess isOpen={openModal} closeModal={closeModal} />
    </>
  )
}

export default CommunityCard
